module.exports = __webpack_public_path__ + "static/img/coupon-model-bg2.b97f4b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coupon-model-bg2.png
// module id = aEb9
// module chunks = 0